import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { passResetViews } from "@rl-appliances/component-library";
import { PAGE_PATH } from "../path";
import ReactQuery from "../enhancers/reactQuery";
import { withSuspense } from "../enhancers/withSuspense";
import { BrowserTitle } from "../components/BrowserTitle";
import NotificationContainer from "../components/NotificationContainer";
import { PAGE_TITLE } from "../titles";

const container = document.getElementById("root");

const LoginContainer = withSuspense(
  React.lazy(() => import("../modules/login/LoginContainer"))
);

const PassResetContainer = withSuspense(
  React.lazy(() => import("../modules/login/PassResetContainer"))
);

if (container == null) {
  console.error("Container element for login module not found!");
} else {
  const root = createRoot(container);
  root.render(
    <ReactQuery>
      <Router>
        <Routes>
          <Route
            path={PAGE_PATH.LOGIN}
            element={
              <BrowserTitle title={PAGE_TITLE.LOGIN}>
                <LoginContainer />
              </BrowserTitle>
            }
          />
          <Route
            path={PAGE_PATH.ADMIN_LOGIN}
            element={
              <BrowserTitle title={PAGE_TITLE.LOGIN}>
                <LoginContainer />
              </BrowserTitle>
            }
          />
          <Route
            path={PAGE_PATH.PASS_RESET_REQUEST}
            element={
              <BrowserTitle title={PAGE_TITLE.RESET_PASSWORD}>
                <PassResetContainer view={passResetViews.EMAIL} />
              </BrowserTitle>
            }
          />
          <Route
            path={PAGE_PATH.PASS_RESET_FORM}
            element={
              <BrowserTitle title={PAGE_TITLE.RESET_PASSWORD}>
                <PassResetContainer view={passResetViews.PASS} />
              </BrowserTitle>
            }
          />
        </Routes>
      </Router>
      <NotificationContainer />
    </ReactQuery>
  );
}
